import { Controller } from "@hotwired/stimulus"

// Single-open accordion for the FAQ. Each item: a button (data-action) + a panel target.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const btn = event.currentTarget
    const idx = Number(btn.dataset.index)
    this.panelTargets.forEach((panel, i) => {
      const open = i === idx && panel.classList.contains("hidden")
      panel.classList.toggle("hidden", !open)
      if (i === idx) btn.setAttribute("aria-expanded", String(open))
    })
  }
}
